import {announce} from '@github-ui/aria-live'
import {type CreateScribeArtifactInput, useCreateScribeArtifact} from '@github-ui/scribe-artifacts'
import {useCallback, useState} from 'react'

type CreateArtifactSubmitInput = Pick<CreateScribeArtifactInput, 'name' | 'description' | 'body' | 'type'>

type UseCreateArtifactSubmitArgs = {
  resourceId: number
  onClose: () => void
  onCreated: () => void
  errorMessage: string
}

export function useCreateArtifactSubmit({resourceId, onClose, onCreated, errorMessage}: UseCreateArtifactSubmitArgs) {
  const [createErrorMessage, setCreateErrorMessage] = useState('')
  const {mutate: createArtifact, isPending} = useCreateScribeArtifact({resourceType: 'issue', resourceId})

  const clearCreateErrorMessage = useCallback(() => {
    setCreateErrorMessage('')
  }, [])

  const submitArtifact = useCallback(
    (input: CreateArtifactSubmitInput) => {
      createArtifact(input, {
        onSuccess: () => {
          onCreated()
          onClose()
        },
        onError: () => {
          setCreateErrorMessage(errorMessage)
          announce(errorMessage, {assertive: true})
        },
      })
    },
    [createArtifact, errorMessage, onClose, onCreated],
  )

  return {clearCreateErrorMessage, createErrorMessage, isPending, submitArtifact}
}
